import { render, staticRenderFns } from "./ForDashboard.vue?vue&type=template&id=0316249d&scoped=true"
import script from "./ForDashboard.vue?vue&type=script&lang=js"
export * from "./ForDashboard.vue?vue&type=script&lang=js"
import style0 from "./ForDashboard.vue?vue&type=style&index=0&id=0316249d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0316249d",
  null
  
)

export default component.exports